<template>
  <van-popup v-model="showFlag" position="bottom" @click-overlay="clickMask">
    <Header class="van-hairline--bottom" show-right rightIcon="icon-close" title="选择体检中心"
            @clickRight="clickMask"></Header>
    <!-- <van-tree-select style="height:340px;" :items="treeList" :main-active-index="mainActiveIndex" :active-id="activeId" @navclick="onNavClick" @itemclick="onItemClick" /> -->
    <div class="tree-wrap row">
      <div class="col-4">
        <Item class="clear-bg text-center" :class="{active:item.id===activeId}" v-for="(item,index) in treeItems"
              :title="item.name" :key="index" @click="navClick(item)"></Item>
      </div>
      <div class="col-8">
        <Item vTag="a" :to="item.id" class="clear-bg text-center van-hairline--bottom"
              :class="{active:item.id===subActiveId}" v-for="(item,index) in childList" :title="item.name" :key="index"
              @click="itemClick(item)"></Item>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Item from '../item'
import Header from '../header'
import { Popup } from 'vant'
import Vue from 'vue'
Vue.use(Popup)
export default {
  name: 'icon',
  components: {
    Item,
    Header
  },
  data () {
    return {
      flag: false
    }
  },
  props: {
    treeItems: {
      type: Array,
      default: []
    },
    activeId: '',
    subActiveId: '',
    showModal: {
      type: Boolean
    }
  },
  computed: {
    showFlag: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    },
    childList () {
      try {
        return this.treeItems.filter(item => {
          return item.id === this.activeId
        })[0].children
      } catch (err) {
        return []
      }
    }
  },
  methods: {
    navClick (e) {
      this.$emit('navClick', e)
    },
    clickMask (e) {
      this.$emit('maskClick', e)
    },
    itemClick (e) {
      this.$emit('itemClick', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.head-title {
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 16px;
}

.tree-wrap {
  height: 495px;
  > div {
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    .active /deep/ {
      background: $light !important;
      h3 {
        color: $assertive;
      }
    }
  }
  .col-4 {
    background: $grey;
  }
}
</style>
